<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
  </div>
</template>
<script>
import { isPC } from 'utils/util';
import store from 'store';
import { reqVideoInfo } from 'api/common';
export default {
  name: 'app',
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      isRouterAlive: true
    }
  },
  methods: {
    reload(params) {
      if(params === 'accountInfoChange') {
        store.dispatch('getUserInfo');
      }
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },
  },
  created() {
    if(!isPC()) {
      this.$nextTick(() => {
        $('#app').css('height', window.innerHeight);
      });
    }
  }
}
</script>

<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #515151;
  font-size: 14px;
  width: 100%;
  min-width: 1320px;
  height: 100vh;
  overflow-y: scroll;
}
</style>
